import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "vehicleCardFreeItemWrapperComponent" }
const _hoisted_2 = {
  key: 0,
  class: "free-car-item-wrapper d-flex flex-wrap g-footer"
}
const _hoisted_3 = ["data-bs-content"]
const _hoisted_4 = ["data-bs-content"]
const _hoisted_5 = ["data-bs-content"]
const _hoisted_6 = ["data-bs-content"]
const _hoisted_7 = ["data-bs-content"]
const _hoisted_8 = ["data-bs-content"]
const _hoisted_9 = {
  key: 1,
  class: "parent-items-container align-content-end gap-1 gap-sm-1"
}
const _hoisted_10 = { class: "d-flex align-items-center p-lg-1 p-xl-3" }
const _hoisted_11 = ["data-bs-content"]
const _hoisted_12 = { class: "ps-md-2 ps-4 free-car-item-text" }
const _hoisted_13 = { class: "d-flex align-items-center p-lg-1 p-xl-3" }
const _hoisted_14 = ["data-bs-content"]
const _hoisted_15 = { class: "ps-md-2 ps-4 free-car-item-text" }
const _hoisted_16 = { class: "d-flex align-items-center p-lg-1 p-xl-3" }
const _hoisted_17 = ["data-bs-content"]
const _hoisted_18 = { class: "ps-md-2 ps-4 free-car-item-text" }
const _hoisted_19 = { class: "d-flex align-items-center p-lg-1 p-xl-3" }
const _hoisted_20 = ["data-bs-content"]
const _hoisted_21 = { class: "ps-md-2 ps-4 free-car-item-text" }
const _hoisted_22 = { class: "d-flex align-items-center p-lg-1 p-xl-3" }
const _hoisted_23 = ["data-bs-content"]
const _hoisted_24 = { class: "ps-md-2 ps-4 free-car-item-text" }
const _hoisted_25 = { class: "d-flex align-items-center p-lg-1 p-xl-3" }
const _hoisted_26 = ["data-bs-content"]
const _hoisted_27 = { class: "ps-md-2 ps-4 free-car-item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VehicleCardFreeItemComponent = _resolveComponent("VehicleCardFreeItemComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.showItemText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_VehicleCardFreeItemComponent, null, {
            freeItem: _withCtx(() => [
              _createElementVNode("span", {
                id: "example",
                class: "d-inline-block",
                tabindex: "0",
                "data-bs-toggle": "popover",
                "data-bs-trigger": "hover focus",
                "data-bs-content": _ctx.$t('free_wifi')
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "image-parent" }, [
                  _createElementVNode("img", {
                    src: "/assets/images/wifi-1.png",
                    alt: "",
                    srcset: ""
                  })
                ], -1)
              ]), 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(_component_VehicleCardFreeItemComponent, null, {
            freeItem: _withCtx(() => [
              _createElementVNode("span", {
                id: "example",
                class: "d-inline-block",
                tabindex: "0",
                "data-bs-toggle": "popover",
                "data-bs-trigger": "hover focus",
                "data-bs-content": _ctx.$t('audio_equipment')
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "image-parent" }, [
                  _createElementVNode("img", {
                    src: "/assets/images/headphones-1.png",
                    alt: "",
                    srcset: ""
                  })
                ], -1)
              ]), 8, _hoisted_4)
            ]),
            _: 1
          }),
          _createVNode(_component_VehicleCardFreeItemComponent, null, {
            freeItem: _withCtx(() => [
              _createElementVNode("span", {
                id: "example",
                class: "d-inline-block",
                tabindex: "0",
                "data-bs-toggle": "popover",
                "data-bs-trigger": "hover focus",
                "data-bs-content": _ctx.$t('microphone')
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "image-parent" }, [
                  _createElementVNode("img", {
                    src: "/assets/images/mic-1.png",
                    alt: "",
                    srcset: ""
                  })
                ], -1)
              ]), 8, _hoisted_5)
            ]),
            _: 1
          }),
          _createVNode(_component_VehicleCardFreeItemComponent, null, {
            freeItem: _withCtx(() => [
              _createElementVNode("span", {
                id: "example",
                class: "d-inline-block",
                tabindex: "0",
                "data-bs-toggle": "popover",
                "data-bs-trigger": "hover focus",
                "data-bs-content": _ctx.$t('multimedia')
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "image-parent" }, [
                  _createElementVNode("img", {
                    src: "/assets/images/youtube-1.png",
                    alt: "",
                    srcset: ""
                  })
                ], -1)
              ]), 8, _hoisted_6)
            ]),
            _: 1
          }),
          _createVNode(_component_VehicleCardFreeItemComponent, null, {
            freeItem: _withCtx(() => [
              _createElementVNode("span", {
                id: "example",
                class: "d-inline-block",
                tabindex: "0",
                "data-bs-toggle": "popover",
                "data-bs-trigger": "hover focus",
                "data-bs-content": _ctx.$t('electrical_connection')
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "image-parent" }, [
                  _createElementVNode("img", {
                    src: "/assets/images/zap-1.png",
                    alt: "",
                    srcset: ""
                  })
                ], -1)
              ]), 8, _hoisted_7)
            ]),
            _: 1
          }),
          _createVNode(_component_VehicleCardFreeItemComponent, null, {
            freeItem: _withCtx(() => [
              _createElementVNode("span", {
                id: "example",
                class: "d-inline-block",
                tabindex: "0",
                "data-bs-toggle": "popover",
                "data-bs-trigger": "hover focus",
                "data-bs-content": _ctx.$t('conditioner')
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "image-parent" }, [
                  _createElementVNode("img", {
                    src: "/assets/images/conditioner-1.png",
                    alt: "",
                    srcset: ""
                  })
                ], -1)
              ]), 8, _hoisted_8)
            ]),
            _: 1
          })
        ]))
      : (_ctx.showItemText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_VehicleCardFreeItemComponent, null, {
                freeItem: _withCtx(() => [
                  _createElementVNode("span", {
                    id: "example",
                    class: "d-inline-block",
                    tabindex: "0",
                    "data-bs-toggle": "popover",
                    "data-bs-trigger": "hover focus",
                    "data-bs-content": _ctx.$t('free_wifi')
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "image-parent" }, [
                      _createElementVNode("img", {
                        src: "/assets/images/wifi-1.png",
                        alt: "",
                        srcset: ""
                      })
                    ], -1)
                  ]), 8, _hoisted_11)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('free_wifi')), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_VehicleCardFreeItemComponent, null, {
                freeItem: _withCtx(() => [
                  _createElementVNode("span", {
                    id: "example",
                    class: "d-inline-block",
                    tabindex: "0",
                    "data-bs-toggle": "popover",
                    "data-bs-trigger": "hover focus",
                    "data-bs-content": _ctx.$t('audio_equipment')
                  }, _cache[7] || (_cache[7] = [
                    _createElementVNode("div", { class: "image-parent" }, [
                      _createElementVNode("img", {
                        src: "/assets/images/headphones-1.png",
                        alt: "",
                        srcset: ""
                      })
                    ], -1)
                  ]), 8, _hoisted_14)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('audio_equipment')), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_VehicleCardFreeItemComponent, null, {
                freeItem: _withCtx(() => [
                  _createElementVNode("span", {
                    id: "example",
                    class: "d-inline-block",
                    tabindex: "0",
                    "data-bs-toggle": "popover",
                    "data-bs-trigger": "hover focus",
                    "data-bs-content": _ctx.$t('microphone')
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "image-parent" }, [
                      _createElementVNode("img", {
                        src: "/assets/images/mic-1.png",
                        alt: "",
                        srcset: ""
                      })
                    ], -1)
                  ]), 8, _hoisted_17)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('microphone')), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_VehicleCardFreeItemComponent, null, {
                freeItem: _withCtx(() => [
                  _createElementVNode("span", {
                    id: "example",
                    class: "d-inline-block",
                    tabindex: "0",
                    "data-bs-toggle": "popover",
                    "data-bs-trigger": "hover focus",
                    "data-bs-content": _ctx.$t('multimedia')
                  }, _cache[9] || (_cache[9] = [
                    _createElementVNode("div", { class: "image-parent" }, [
                      _createElementVNode("img", {
                        src: "/assets/images/youtube-1.png",
                        alt: "",
                        srcset: ""
                      })
                    ], -1)
                  ]), 8, _hoisted_20)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('multimedia')), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_VehicleCardFreeItemComponent, null, {
                freeItem: _withCtx(() => [
                  _createElementVNode("span", {
                    id: "example",
                    class: "d-inline-block",
                    tabindex: "0",
                    "data-bs-toggle": "popover",
                    "data-bs-trigger": "hover focus",
                    "data-bs-content": _ctx.$t('electrical_connection')
                  }, _cache[10] || (_cache[10] = [
                    _createElementVNode("div", { class: "image-parent" }, [
                      _createElementVNode("img", {
                        src: "/assets/images/zap-1.png",
                        alt: "",
                        srcset: ""
                      })
                    ], -1)
                  ]), 8, _hoisted_23)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('electrical_connection')), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_VehicleCardFreeItemComponent, null, {
                freeItem: _withCtx(() => [
                  _createElementVNode("span", {
                    id: "example",
                    class: "d-inline-block",
                    tabindex: "0",
                    "data-bs-toggle": "popover",
                    "data-bs-trigger": "hover focus",
                    "data-bs-content": _ctx.$t('conditioner')
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("div", { class: "image-parent" }, [
                      _createElementVNode("img", {
                        src: "/assets/images/conditioner-1.png",
                        alt: "",
                        srcset: ""
                      })
                    ], -1)
                  ]), 8, _hoisted_26)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('conditioner')), 1)
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", null, null, -1))
          ]))
        : _createCommentVNode("", true)
  ]))
}